import React from "react";
import { Link } from "react-router-dom";
import PageHero from "@/components/PageHero";
import { useSeo } from "@/lib/seo";

export default function MentionsLegales() {
  useSeo({
    title: "Mentions légales | My Animation",
    description:
      "Mentions légales du site My Animation — DJ événementiel dans les Hauts-de-France, le Nord, le Pas-de-Calais et la Belgique. SIRET 53238715600039.",
    path: "/mentions-legales",
    keywords: "mentions légales My Animation",
  });

  return (
    <>
      <PageHero
        eyebrow="Informations légales"
        title={<>Mentions <span className="italic gold-text">légales.</span></>}
        subtitle="Informations relatives à l'édition, à l'hébergement et à la propriété du site myanimation.fr."
        img="https://images.pexels.com/photos/9665186/pexels-photo-9665186.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
      />

      <section className="py-20 md:py-28 px-6 md:px-10 lg:px-14 max-w-[900px] mx-auto">
        <div className="card-luxe p-8 md:p-12 space-y-10">
          <Block title="Éditeur du site">
            <P><strong>My Animation</strong> — Créateur d'ambiance et d'événement</P>
            <P>SIRET : 532 387 156 00039</P>
            <P>Zone d'intervention : Hauts-de-France, Nord, Pas-de-Calais, Belgique</P>
            <P>
              Téléphone : <a className="text-[#DCB457] hover:underline" href="tel:0769224956">07 69 22 49 56</a>
            </P>
            <P>
              E-mail : <a className="text-[#DCB457] hover:underline" href="mailto:my-animation@outlook.fr">my-animation@outlook.fr</a>
            </P>
            <P>
              Site officiel : <a className="text-[#DCB457] hover:underline" href="https://myanimation.fr" target="_blank" rel="noopener noreferrer">myanimation.fr</a>
            </P>
          </Block>

          <Block title="Directeur de la publication">
            <P>
              Le responsable de la publication du site est l'exploitant individuel
              de l'entreprise My Animation, joignable via les coordonnées ci-dessus.
            </P>
          </Block>

          <Block title="Hébergement du site">
            <P>
              Le site est hébergé par un prestataire technique professionnel. Les
              informations détaillées de l'hébergeur peuvent être obtenues sur
              simple demande à l'adresse my-animation@outlook.fr.
            </P>
          </Block>

          <Block title="Propriété intellectuelle">
            <P>
              L'ensemble des éléments présents sur le site myanimation.fr —
              textes, photographies, logos, identité visuelle, charte graphique —
              est protégé par le droit de la propriété intellectuelle et reste la
              propriété exclusive de My Animation ou de ses partenaires.
            </P>
            <P>
              Toute reproduction, représentation ou diffusion, totale ou partielle,
              sans autorisation écrite préalable est strictement interdite.
            </P>
          </Block>

          <Block title="Responsabilité">
            <P>
              My Animation s'efforce d'assurer l'exactitude et la mise à jour des
              informations diffusées sur ce site, mais ne peut garantir l'absence
              d'erreurs ou d'omissions. L'utilisateur reste seul responsable de
              l'usage qu'il fait des informations du site.
            </P>
          </Block>

          <Block title="Données personnelles">
            <P>
              Les données transmises via le formulaire de demande de devis sont
              utilisées uniquement pour traiter votre demande. Pour en savoir plus,
              consultez notre{" "}
              <Link to="/politique-confidentialite" className="text-[#DCB457] hover:underline">
                politique de confidentialité
              </Link>.
            </P>
          </Block>

          <Block title="Litiges">
            <P>
              Les présentes mentions légales sont soumises au droit français.
              Tout litige relatif à l'utilisation du site relèvera de la
              compétence des tribunaux français.
            </P>
          </Block>
        </div>
      </section>
    </>
  );
}

function Block({ title, children }) {
  return (
    <div>
      <h2 className="font-serif-luxe text-2xl md:text-3xl mb-3">
        <span className="italic gold-text">{title}</span>
      </h2>
      <div className="space-y-2 text-white/70 leading-relaxed text-[15px]">{children}</div>
    </div>
  );
}

function P({ children }) {
  return <p>{children}</p>;
}
